import Modal from 'react-bootstrap/Modal';

const ViewDetailsModal = ({ show, setShow, title, body, footer="" }) => {
    // const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{body}</Modal.Body>
                {footer && <Modal.Footer>
                    {footer}
                </Modal.Footer>}
            </Modal>
        </>
    );
}

export default ViewDetailsModal;